import { h } from './dom.ts';

// The two drawings are fixed strings (no typed text goes into them).
const EYE =
  '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>';
const EYE_SHUT =
  '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9.9 5.1A10.4 10.4 0 0 1 12 5c6.4 0 10 7 10 7a17.7 17.7 0 0 1-3.2 4.2M6.6 6.6C3.9 8.4 2 12 2 12s3.6 7 10 7a9.7 9.7 0 0 0 5.4-1.6"/><path d="M9.9 9.9a3 3 0 0 0 4.2 4.2"/><path d="M3 3l18 18"/></svg>';

/**
 * A password box with an eye at its end (owner, 2026-10-27: "يشوف إذا كاتبها صح"): pressing it shows
 * what was typed, pressing again hides it, and it hides again when the form is sent (so a password
 * manager still sees a password).
 */
export function passwordInput(attrs: Record<string, string | boolean | number>, labels: { show: string; hide: string }): HTMLElement {
  const input = h('input', { ...attrs, type: 'password', dir: 'ltr', class: 'pw-input' });
  const eye = h('button', { type: 'button', class: 'pw-eye', 'aria-label': labels.show, 'aria-pressed': 'false', title: labels.show });
  const show = (shown: boolean) => {
    input.type = shown ? 'text' : 'password';
    eye.innerHTML = shown ? EYE_SHUT : EYE;
    eye.setAttribute('aria-label', shown ? labels.hide : labels.show);
    eye.setAttribute('title', shown ? labels.hide : labels.show);
    eye.setAttribute('aria-pressed', String(shown));
  };
  show(false);
  eye.addEventListener('click', () => {
    show(input.type === 'password');
    input.form?.addEventListener('submit', () => show(false), { once: true });
    input.focus();
  });
  return h('span', { class: 'pw-wrap' }, input, eye);
}
